import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { GetUsersOptions } from "@xapp/stentor-api-client/dist/api/orgs/orgId/users/Users";

import { getOrgId, GetUsersOfOrgReturn, OrganizationId } from "api";
import { Credentials } from "auth";
import { State } from "redux/state";

export type FetchUsersOfOrganization = "GET_USERS_OF_ORG";
export const FETCH_USERS_OF_ORGANIZATION: FetchUsersOfOrganization = "GET_USERS_OF_ORG";
export type FetchUsersOfOrganizationEnd = "GET_USERS_OF_ORG_END";
export const FETCH_USERS_OF_ORGANIZATION_END: FetchUsersOfOrganizationEnd = "GET_USERS_OF_ORG_END";

export interface FetchUsersOfOrganizationAction extends Action {
    payload: {
        credentials: Credentials;
        organizationId: string;
    };
    type: FetchUsersOfOrganization;
}

export function fetchUsersOfOrganization(
    organizationId: OrganizationId,
    options: GetUsersOptions
): ThunkAction<any, State, undefined, FetchUsersOfOrganizationAction> {
    return (dispatch: Dispatch<FetchUsersOfOrganizationAction>, getState) => {
        const state = getState();
        dispatch(fetchUsersOfOrganizationWithCredentials(organizationId, state.auth.credentials));
    };
}

function fetchUsersOfOrganizationWithCredentials(
    organizationId: OrganizationId,
    credentials: Credentials
): FetchUsersOfOrganizationAction {
    return {
        payload: {
            credentials,
            organizationId: getOrgId(organizationId)
        },
        type: FETCH_USERS_OF_ORGANIZATION
    };
}

export interface FetchUsersOfOrganizationEndAction extends Action {
    payload: {
        organizationId: string;
        result?: GetUsersOfOrgReturn;
        error?: Error;
    };
    type: FetchUsersOfOrganizationEnd;
}

export function fetchUsersOfOrganizationEnd(
    error: Error,
    organizationId: string,
    result?: GetUsersOfOrgReturn
): FetchUsersOfOrganizationEndAction {
    return {
        payload: {
            error,
            organizationId,
            result
        },
        type: FETCH_USERS_OF_ORGANIZATION_END
    };
}
